import { render, staticRenderFns } from "./EducationalStageCards.vue?vue&type=template&id=3d8ce8fa&"
import script from "./EducationalStageCards.vue?vue&type=script&lang=js&"
export * from "./EducationalStageCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports